import script from "./Url.vue?vue&type=script&setup=true&lang=js"
export * from "./Url.vue?vue&type=script&setup=true&lang=js"

import "./Url.vue?vue&type=style&index=0&id=551aa57d&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-551aa57d"]])

export default __exports__